import { Component, OnInit } from '@angular/core';
import { UsersService } from 'src/app/services/users.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  isClientUsr:boolean;
  isBuhoUsr: boolean = false;
  modules :any;


  constructor(private userS:UsersService, ) { 
    this.isClientUsr = (this.userS.getUser().id_rol == environment.role_client_id);
    this.isBuhoUsr = (this.userS.getUser().id_rol == environment.role_buho_id || this.userS.getUser().id_rol == environment.role_admin_id);
    this.modules = this.userS.getUserModules();
  }

  ngOnInit(): void {
  }

  hasDashboard(){
    return this.isBuhoUsr ? true :  this.modules.filter((e:any) => e.clave === 'dash').length > 0
  }
  hasSeguimientoPP(){
    return this.isBuhoUsr ? true :  this.modules.filter((e:any) => e.clave === 'seg').length > 0
  }
  hasCampanas(){
    return this.isBuhoUsr ? true :  this.modules.filter((e:any) => e.clave === 'camp').length > 0
  }
  hasMateriales(){
    return this.isBuhoUsr ? true :  this.modules.filter((e:any) => e.clave === 'mat').length > 0
  }
  hasUsuarios(){
    return this.isBuhoUsr ? true :  this.modules.filter((e:any) => e.clave === 'usua').length > 0
  }
  hasEncintado(){
    return this.isBuhoUsr ? true :  this.modules.filter((e:any) => e.clave === 'encin').length > 0
  }
  hasInventario(){
    return this.isBuhoUsr ? true :  this.modules.filter((e:any) => e.clave === 'inv').length > 0
  }
  hasPTL(){
    return this.isBuhoUsr ? true :  this.modules.filter((e:any) => e.clave === 'ptl').length > 0
  }

}
